import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TegelModule } from '@scania/tegel-angular-17';
import { DeskPopoverComponent } from '../../desk-popover/desk-popover.component';
import { ReservationListComponent } from '../../reservation-list/reservation-list.component';
import { BuildingAdminComponent } from '../../../admin/building-admin/building-admin.component';
import { P34_DESKS } from '../shared/constants/p34.desks';
import { BuildingReservationsBase } from '../shared/reservation-base';

@Component({
  selector: 'app-p34',
  imports: [ReservationListComponent, TegelModule, DeskPopoverComponent, BuildingAdminComponent, CommonModule],
  templateUrl: './p34.component.html',
  styleUrl: './p34.component.scss'
})
export class P34Component extends BuildingReservationsBase {
  public readonly desks = P34_DESKS;
}